import { render, staticRenderFns } from "./ConsumerKeys.vue?vue&type=template&id=5ae4564a&"
import script from "./ConsumerKeys.vue?vue&type=script&lang=js&"
export * from "./ConsumerKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ae4564a')) {
      api.createRecord('5ae4564a', component.options)
    } else {
      api.reload('5ae4564a', component.options)
    }
    module.hot.accept("./ConsumerKeys.vue?vue&type=template&id=5ae4564a&", function () {
      api.rerender('5ae4564a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/ConsumerKeys.vue"
export default component.exports